import $ from 'jquery';
import config from './../../config';
const URL_API = config.urlApi+'controlador/unidades/getEgresosTotalesUnidad.php';

export default function getEgresosTotalesUnidad({values}){
    return $.ajax({
        url: URL_API,
        type: 'POST',
        data: values
    })
}